module.exports = __webpack_public_path__ + "static/media/home_empty_normal_bg.28143b7c.png";